var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('NP-SplashScreen',[_c('div',{staticClass:"form"},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"item"}),_c('div',{staticClass:"item"})]),_c('div',{staticClass:"table"})])])}
var staticRenderFns = []

export { render, staticRenderFns }